// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2klpA","productName":"Table_productName__1Pd-J"};